import React from 'react';

export default function ExistingMemberConfirmation() {
  return (
    <div className="homeContainer">
      <div className="homeWelcomeContent reset-password">
        <div className='container-fluid'>
          <h1>
            Existing Membership Request Submitted
          </h1>
          <p> We have received your request to create an account with an existing membership. Please give us a few business days to process your request.</p>
          <p>If you do not hear from us, feel free to give us a call. As always, feel free to contact us with any questions. </p>
        </div>
      </div>
    </div>
  )
}


